/*
 * Hyper link component
 */
import React from 'react';

import Base from './base.jsx'; 
import {
  castDataType,
  DataType
} from '../common.jsx'
import Setting from "./setting.jsx";


export default class HyperLink extends Base {

        static get ANSWER_DEPENDENT() {
          return false
        }

        static get CATEGORY() {
            return 'other';
        }

        static get TYPE() {
            return 'hyper_link';
        }

        static icon(){
            return <i className="fa fa-link"></i>;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                label: 'field_default_link_label',
                description: 'field_default_description',
                text: null
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                label: 'label',
                text: 'text',
                url: '',
                description: 'description',
                guideline: false,
                prettyView: {
                    hide: false,
                    show_label: false
                }
            });
        }

        renderView() {
            let url = this.props.content.url || '';
            let anchor = url.length > 0 ?
                <a href={url.match(/^http/i) ? url : 'http://' + url} target="_blank">{(this.getText('text') || '').length > 0 ? this.getText('text') : url}</a> : null;
            return (
                <div>
                    <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                        <span className="field-label">{this.getText('label')}</span>
                    </label>
                    <p className="link">
                        {anchor ? anchor : <em>[{I18n.t('link_undefined_text', {scope: 'fe'})}]</em>}
                    </p>
                    {this.descriptionText()}
                </div>
            );
        }

        renderPrettyView() {
            let url = this.props.content.url || '';
            let anchor = url.length > 0 ?
                <a href={url.match(/^http/i) ? url : 'http://' + url} target="_blank">{(this.getText('text') || '').length > 0 ? this.getText('text') : url}</a> : null;
            const { hide = false, show_label = false } = this.props.content.prettyView || {};

            return ((!this.props.content.guideline && !hide) ?
                <div>
                    {show_label &&
                        <label>
                            <span className="field-label">{this.getText('label')}</span>
                        </label>
                    }
                    <p className="link">
                        {anchor ? anchor : <em>[{I18n.t('link_undefined_text', {scope: 'fe'})}]</em>}
                    </p>
                </div> : null
            );
        }

        renderSettings() {
            return (
                <div>
                    <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
                    <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />  
                    <Setting.TextField name="url" label={I18n.t('field_url', {scope: 'fe'})} value={this.props.content.url} onChange={this.updateSettings} />
                    <Setting.TextField name="text" label={I18n.t('field_text', {scope: 'fe'})} value={this.getText('text')} onChange={this.updateSettings} />
                    <Setting.TextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
                    <Setting.Checkbox name="guideline" label={I18n.t('guideline', {scope: 'fe'})} value={this.props.content.guideline} onChange={this.updateSettings} />   
                    {this.renderPrettyViewSettings()} 
                </div>
            );
        }

        beforeUpdateSettings(content) {
            content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
            content.guideline = castDataType(content.guideline, DataType.BOOLEAN);
            this.beforeUpdateSettingsPrettyView(content);
        }
}
